module.exports = __webpack_public_path__ + "static/media/06B.4d30c12a.png";